<template>
  <div class="news">
    <TopNavBar :navtitle="ChannelsCName"></TopNavBar>
    <div class="article">
      <h1>{{ NewsInfo.Title }}</h1>
      <div class="article-date">
        <label for=""
          ><i class="iconfont icon-chakan"></i>{{ NewsInfo.ClickNum }}
        </label>
        <span>
          <i class="iconfont icon-shijian1"></i>{{ NewsInfo.UpTime }}
        </span>
      </div>
      <div class="article-content" v-html="NewsInfo.Info"></div>
    </div>
    <van-overlay :show="showload">
      <van-loading size="50px" vertical class="wrapper">加载中...</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import TopNavBar from "@/components/TopNavBar.vue";
import { GetNewsInfo } from "@/api/public";
import wx from "weixin-js-sdk";
export default {
  components: {
    TopNavBar,
  },
  data() {
    return {
      NewsInfo: {},
      ChannelsCName: "",
      showload: true,
    };
  },
  created() {
    if (
      this.$route.query.News_ID != undefined &&
      this.$route.query.News_ID > 0
    ) {
      GetNewsInfo({ NewsID: this.$route.query.News_ID }).then((result) => {
        this.NewsInfo = result.item;
        this.ChannelsCName = result.item.Channels.CName;
        this.showload = false;

        let title =
         this.NewsInfo.Title&&this.NewsInfo.Title != ""
            ? this.NewsInfo.Title
            : "黔音在线";
        let link =
         window.location.href;
        let desc =
         this.NewsInfo.IndexInfo&& this.NewsInfo.IndexInfo !=""
            ? this.NewsInfo.IndexInfo
            : "贵州省音乐家协会【黔音在线】通过全新系统的改版建设，帮助协会发布考级通知、考生在线报名、在线考试、考官在线评审、考生证书邮寄等功能的综合业务系统以及贵州省音协的各项工作动态和成果。";
        let imgUrl =
          this.NewsInfo.PicPath&& this.NewsInfo.PicPath != ""
            ? this.NewsInfo.PicPath
            : window.location.protocol +
              "//" +
              window.location.host +
              "/" +
              logo;
        //配置全局微信分享
        wx.ready(function () {
          wx.updateTimelineShareData({
            title: title, // 分享标题
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: function () {
              console.log("分享成功");
            },
          });
          wx.updateAppMessageShareData({
            title: title, // 分享标题
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            desc: desc, // 分享索引
            success: function () {
              console.log("分享成功");
            },
          });
        });
      });
    } else {
      this.$router.push("/404");
    }
  },
};
</script>

<style>
</style>